/* [SOP-202] – PLP fallback for products without color swatches
   Purpose: if a product tile <img> has empty src/srcset because there is no
   "Color/Print Name" option, hydrate it with the product's featured image.

   Safe to include on any collection page. Idempotent. No dependencies.
*/
(function () {
  "use strict";

  function urlWithWidth(url, w) {
    if (!url) return "";
    // Shopify CDN supports ?width=
    const sep = url.indexOf("?") === -1 ? "?" : "&";
    return url + sep + "width=" + w;
  }

  function setSrcAndSrcset(img, rawUrl) {
    if (!img || !rawUrl) return;
    // Some Shopify endpoints return either strings or objects
    var url = typeof rawUrl === "string" ? rawUrl : (rawUrl && (rawUrl.src || rawUrl.url || rawUrl.originalSrc));
    if (!url) return;
    // Small, sensible srcset
    var widths = [320, 480, 640, 800, 960, 1200];
    try {
      img.src = urlWithWidth(url, 320);
      img.srcset = widths.map(function (w) { return urlWithWidth(url, w) + " " + w + "w"; }).join(", ");
      if (!img.sizes || !img.sizes.trim()) {
        img.sizes = "(max-width: 600px) 275px, 320px";
      }
      img.loading = img.loading || "lazy";
      img.setAttribute("data-plp-fallback", "applied");
    } catch (e) {
      console.warn("PLP fallback: failed to set image", e);
    }
  }

  function getHandleFromHref(href) {
    if (!href) return "";
    try {
      var m = href.split("/products/")[1] || "";
      m = m.split("?")[0];
      return (m || "").replace(/\/+$/, "");
    } catch (e) {
      return "";
    }
  }

  function hydrateOneTile(tile) {
    try {
      var a = tile.querySelector("a[data-product-id]");
      if (!a) return;
      var img = a.querySelector("img");
      if (!img) return;

      var hasSrc = (img.getAttribute("src") || "").trim() !== "";
      var hasSrcset = (img.getAttribute("srcset") || "").trim() !== "";
      if (hasSrc || hasSrcset) return; // already populated by theme

      var handle = getHandleFromHref(a.getAttribute("href"));
      if (!handle) return;

      // Use Shopify product JSON endpoint
      fetch("/products/" + handle + ".js", { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          // p.images can be array of strings or objects; prefer featured image if present
          var fallback =
            (p.featured_image && (p.featured_image.src || p.featured_image)) ||
            (Array.isArray(p.images) && (p.images[0] && (p.images[0].src || p.images[0]))) ||
            p.image;

          if (!fallback) {
            console.warn("PLP fallback: product JSON had no image", p && p.id);
            return;
          }
          setSrcAndSrcset(img, fallback);
        })
        .catch(function (e) { console.warn("PLP fallback: fetch failed", e); });
    } catch (e) {
      console.warn("PLP fallback: hydrateOneTile error", e);
    }
  }

  function runOnPage() {
    // target tiles where theme left image empty
    var tiles = document.querySelectorAll('a[data-product-id] > img[srcset=""], a[data-product-id] > img:not([srcset])');
    if (!tiles.length) return;

    tiles.forEach(function (img) {
      var tile = img.closest("[class]") || document; // climb a little
      hydrateOneTile(tile);
    });
  }

  // Initial run
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runOnPage);
  } else {
    runOnPage();
  }

  // Observe dynamically-added tiles
  var obs = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && (n.matches('a[data-product-id] > img[srcset=""]') || n.matches('a[data-product-id] > img:not([srcset])'))) {
          hydrateOneTile(n.closest("[class]") || n);
        } else if (n.querySelectorAll) {
          var imgs = n.querySelectorAll('a[data-product-id] > img[srcset=""], a[data-product-id] > img:not([srcset])');
          imgs.forEach(function (img) { hydrateOneTile(img.closest("[class]") || n); });
        }
      }
    }
  });
  try {
    obs.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();

